export const LOGOUT = 'Logout'
export const MY_ACCOUNT = 'My Account'
